import * as React from 'react';
import { observer, inject } from 'mobx-react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  CircularProgress,
} from '@mui/material';
import AccountService from '../../service/AccountService';
import { observable } from 'mobx';
import autobind from 'autobind-decorator';
import { withStyles } from '@mui/styles';

const StyledDialog = withStyles({
  paper: {
    minWidth: '40%',
  },
})(Dialog);

type SaveDialogProps = {
  dialogOpen?: boolean;
  onDialogClose?: () => void;
  account?: AccountService;
  handleSave?: () => void;
};

type SaveDialogState = {};

@inject('account')
@inject('routing')
@observer
export default class SaveDialog extends React.Component<
  SaveDialogProps,
  SaveDialogState
> {
  state = {};

  @observable
  private _loading = false;

  @autobind
  async saveHandler(event: any = null) {
    var { handleSave, account } = this.props;
    if (event != null) {
      event.preventDefault();
    }
    this._loading = true;
    if (handleSave != null) {
      await handleSave();
    }
    this._loading = false;
    account.goBack();
  }

  render() {
    let { dialogOpen, onDialogClose, account } = this.props;
    return (
      <StyledDialog open={dialogOpen} onClose={onDialogClose}>
        <DialogTitle>Save workflow</DialogTitle>
        <DialogContent
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '1rem',
          }}
        >
          <p style={{ fontSize: '1.2rem', marginBottom: '1.3rem' }}>
            Do you want to save the changes?
          </p>
          <div>
            <Button
              variant='contained'
              color='inherit'
              style={{ margin: '0 2rem' }}
              onClick={() => account.goBack()}
            >
              cancel
            </Button>
            <Button
              variant='contained'
              color='primary'
              style={{
                margin: '0 2rem',
                height: '36px',
              }}
              onClick={this.saveHandler}
            >
              {this._loading ? (
                <CircularProgress
                  size={20}
                  style={{
                    color: 'white',
                  }}
                />
              ) : (
                'save'
              )}
            </Button>
          </div>
        </DialogContent>
      </StyledDialog>
    );
  }
}
